// src/pages/Login.jsx
import { useState } from 'react';
import { 
  TextInput, 
  PasswordInput, 
  Button, 
  Paper, 
  Title, 
  Container, 
  Notification,
  Text,
  Checkbox,
  Group,
  Anchor,
  Center,
  Box,
  Badge,
  Image
} from '@mantine/core';
import { IconLock, IconUser, IconX, IconArrowRight } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import api from '../api/axiosConfig';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    // OAuth2 standardı gereği form-data formatı
    const params = new URLSearchParams();
    params.append('username', username);
    params.append('password', password);

    try {
      const response = await api.post('/token', params);
      
      const { access_token, user_role } = response.data;
      
      // 1. Token'ı kaydet
      localStorage.setItem('token', access_token);

      // 2. Rolü kaydet
      const roleToSave = user_role || 'personel';
      localStorage.setItem('user_role', roleToSave); 
      
      // 3. Yönlendir
      navigate('/');
      
    } catch (err) {
      console.error("Login Hatası:", err);
      
      if (err.response) {
        if (err.response.status === 401) {
            setError('Kullanıcı adı veya şifre hatalı!');
        } else {
            setError(`Hata: ${err.response.data.detail || 'Bir sorun oluştu'}`);
        }
      } else if (err.code === "ERR_NETWORK") {
        setError('Sunucuya bağlanılamadı. Backend çalışıyor mu?');
      } else {
        setError('Beklenmedik bir hata oluştu.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      style={{
        minHeight: '100vh',
        background: 'radial-gradient(circle at 15% 15%, #5ea8ff 0%, transparent 35%), radial-gradient(circle at 85% 85%, #0b4f8a 0%, transparent 40%), linear-gradient(145deg, #06223b 0%, #0a3d68 48%, #0b5d9e 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      <Box
        style={{
          position: 'absolute',
          top: '-140px',
          right: '-120px',
          width: '340px',
          height: '340px',
          borderRadius: '50%',
          background: 'rgba(255,255,255,0.08)',
          filter: 'blur(2px)'
        }}
      />
      <Box
        style={{
          position: 'absolute',
          bottom: '-180px',
          left: '-120px',
          width: '380px',
          height: '380px',
          borderRadius: '50%',
          background: 'rgba(255,255,255,0.06)',
          filter: 'blur(2px)'
        }}
      />

      <Container size={460} w="100%" style={{ position: 'relative', zIndex: 2 }}>
        <Center mb={26} style={{ flexDirection: 'column' }}>
          
          {/* İKON YERİNE LOGO GÖRSELİ EKLENDİ */}
          <Image
            src="/logo.png"
            alt="Kurumsal Logo"
            w={82}
            h={82}
            radius={999}
            style={{ 
              boxShadow: '0 18px 35px rgba(3, 24, 46, 0.35)',
              backgroundColor: '#ffffff', // Şeffaf PNG'ler için beyaz arkaplan
              objectFit: 'contain',
              padding: '8px' // Logonun kenarlara çok yapışmaması için hafif boşluk
            }}
          />

          <Badge
            mt="md"
            radius="sm"
            size="md"
            variant="light"
            color="blue"
          >
            Kurumsal Giriş
          </Badge>
          <Title ta="center" c="white" mt={10} fw={900} style={{ letterSpacing: '0.8px' }}>
            SMS GRUP
          </Title>
          <Text c="blue.0" size="sm" ta="center" fw={500}>
            Portal Yönetim Sistemi
          </Text>
        </Center>

        <Paper
          p={34}
          radius="xl"
          bg="rgba(255,255,255,0.96)"
          style={{
            border: '1px solid rgba(255,255,255,0.55)',
            boxShadow: '0 24px 55px rgba(6, 25, 45, 0.28)',
            backdropFilter: 'blur(8px)'
          }}
        >
          {error && (
            <Notification
              icon={<IconX size="1.1rem" />}
              color="red"
              onClose={() => setError(null)}
              mb="lg"
              radius="md"
              withBorder
            >
              {error}
            </Notification>
          )}

          <Text fw={700} size="lg" c="dark.8" mb={4}>
            Hesabınıza giriş yapın
          </Text>
          <Text size="sm" c="dimmed" mb="lg">
            Devam etmek için kullanıcı bilgilerinizi girin.
          </Text>

          <form onSubmit={handleLogin}>
            <TextInput
              label="Kullanıcı Adı"
              placeholder="Kullanıcı adınız"
              required
              size="md"
              radius="md"
              leftSection={<IconUser size="1.05rem" color="var(--mantine-color-gray-6)" />}
              value={username}
              onChange={(event) => setUsername(event.currentTarget.value)}
            />

            <PasswordInput
              label="Şifre"
              placeholder="Şifreniz"
              required
              mt="md"
              size="md"
              radius="md"
              leftSection={<IconLock size="1.05rem" color="var(--mantine-color-gray-6)" />}
              value={password}
              onChange={(event) => setPassword(event.currentTarget.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleLogin(e);
                }
              }}
            />

            <Group justify="space-between" mt="lg">
              <Checkbox label="Beni hatırla" size="sm" />
              <Anchor component="button" size="sm" c="blue.7" onClick={(e) => e.preventDefault()}>
                Şifremi unuttum
              </Anchor>
            </Group>

            <Button
              fullWidth
              mt="xl"
              size="md"
              type="submit"
              loading={loading}
              radius="md"
              variant="gradient"
              gradient={{ from: '#0b5d9e', to: '#1c7ed6', deg: 120 }}
              rightSection={!loading && <IconArrowRight size={18} />}
            >
              Giriş Yap
            </Button>
          </form>
        </Paper>

        <Text ta="center" size="xs" c="white" mt="xl" style={{ opacity: 0.78 }}>
          &copy; {new Date().getFullYear()} SMS Grup İnşaat A.Ş. Tüm hakları saklıdır.
        </Text>
      </Container>
    </Box>
  );
}